/**
 * Founder-established retailer preference.
 * Tie-breaker only. Never overrides price, CURRENT vs STALE, or explicit unavailability.
 * Commission is not an input.
 */

export const FOUNDER_RETAILER_PREFERENCE = Object.freeze([
  'Amazon',
  'Scheels',
  "Cabela's",
  "Sportsman's Warehouse",
  'FishUSA',
  'West Marine',
]);

function normalizeRetailerName(name) {
  return String(name || '')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

const PREFERENCE_RANK = new Map(
  FOUNDER_RETAILER_PREFERENCE.map((name, index) => [normalizeRetailerName(name), index])
);

export function getRetailerPreferenceRank(name) {
  const rank = PREFERENCE_RANK.get(normalizeRetailerName(name));
  return rank == null ? FOUNDER_RETAILER_PREFERENCE.length : rank;
}

export function compareRetailerPreference(aName, bName) {
  const rankA = getRetailerPreferenceRank(aName);
  const rankB = getRetailerPreferenceRank(bName);
  if (rankA !== rankB) return rankA - rankB;
  return String(aName || '').localeCompare(String(bName || ''), 'en', { sensitivity: 'base' });
}
